import {AppState} from "@/store/modules/app/types";
import {ActionTree, GetterTree, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import moment from 'moment';


const state: AppState = {
    selectedFridge: {},
    token: null,

    lastError: null,
}

const getters: GetterTree<AppState, RootState> = {
    fridgeId(state) {
        return state.selectedFridge && state.selectedFridge.department_id
            ? state.selectedFridge.department_id
            : null;
    },
    antennas(state) {
        return state.selectedFridge && state.selectedFridge.antennas
            ? state.selectedFridge.antennas
            : [];
    },
}

const mutations: MutationTree<AppState> = {
    setSelectedFridge(state, value) {
        state.selectedFridge = value;
    },
    setToken(state, value) {
        state.token = String(value).trim();
    },
    setLastError(state, error) {
        state.lastError = error !== null ? {moment: moment(), error: error} : null;
    },
}

const actions: ActionTree<AppState, RootState> = {
    setSelectedFridge({commit}, value) {
        commit('setSelectedFridge', value);
    },
    setToken({commit, dispatch}, value) {
        dispatch('setSelectedFridge', null);
        commit('setToken', value);
    },
    setLastError({commit}, error) {
        commit('setLastError', error);
    },
    clearLastError({commit}) {
        commit('setLastError', null);
    },
}


export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
